<template>
  <section class="blog-more-luxury">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="sectionStyles">
      <div class="container">
        <h2 class="blog_title" v-html="shopifyData.blogHeading" />
        <p class="blog_text" v-html="shopifyData.blogText" />
        <a :href="shopifyData.btnLink" class="btn" v-html="shopifyData.btnTitle" />
      </div>
    </a>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionStyles() {
      return {
        backgroundColor: this.shopifyData.bgColor,
        paddingTop:
          window.innerWidth > 768
            ? this.shopifyData.deskPaddingTop + 'px'
            : this.shopifyData.mobPaddingTop + 'px',
        paddingBottom:
          window.innerWidth > 768
            ? this.shopifyData.deskPaddingBottom + 'px'
            : this.shopifyData.mobPaddingBottom + 'px',
      };
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 83px;
}

.blog-more-luxury {
  text-align: center;
}

.blog-more-luxury a {
  display: block;
}

.blog_title {
  color: #000;
  text-align: center;
  font-family: 'Big Caslon', serif;
  font-size: 72px;
  font-style: normal;
  font-weight: 500;
  line-height: 91%;
  max-width: 630px;
  width: 100%;
}

.blog_text {
  color: #000;
  text-align: center;
  font-family: adobe-caslon-pro, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  max-width: 390px;
  width: 100%;
}

.btn {
  display: inline-block;
  padding: 8px 30px;
  background: #000;
  color: #fff;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.28px;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .blog_title {
    font-size: 36px;
  }

  .blog_text {
    font-size: 20px;
  }

  .container {
    gap: 40px;
  }
}
</style>
